import React from "react";
import ReactDOM from "react-dom";

const CustomLoader = ({ show = true }) => {
  if (!show) return null;

  const loaderContent = (
    <>
      <style>{`
        .custom-loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.85);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999999 !important;
          backdrop-filter: blur(8px);
        }

        .loader-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
        }

        .neon-spinner {
          width: 80px;
          height: 80px;
          border: 6px solid rgba(131, 234, 119, 0.2);
          border-top-color: #83EA77;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          box-shadow: 0 0 20px #83EA77, 0 0 40px rgba(131, 234, 119, 0.5);
        }

        .loader-text {
          color: #83EA77;
          font-size: 16px;
          font-weight: 600;
          text-shadow: 0 0 10px rgba(131, 234, 119, 0.5);
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <div className="custom-loader-overlay">
        <div className="loader-content">
          <div className="neon-spinner"></div>
          <div className="loader-text">Loading...</div>
        </div>
      </div>
    </>
  );

  return ReactDOM.createPortal(loaderContent, document.body);
};

export default CustomLoader;
